import {useQuery, UseQueryResult} from '@tanstack/react-query';

import {fetchCompanyLocations} from './use-companies-locations-api';
import {CompanyLocationType} from './use-companies-locations-type';

export function useCompaniesLocations(): UseQueryResult<Array<CompanyLocationType>> {
    return useQuery(['companies-locations'], () => fetchCompanyLocations(), {
        cacheTime: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    });
}
